<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAuthenticated_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.41 16.81Q9.22 19.3 12 20q2.78-.7 4.59-3.19t1.81-5.53V6.4L12 4 5.6 6.4v4.88q0 3.04 1.81 5.53m7.472-7.845a.563.563 0 1 1 .797.796l-4.474 4.474a.563.563 0 0 1-.797 0l-2.243-2.243a.563.563 0 1 1 .797-.797l1.844 1.845z"
        clip-rule="evenodd"
    />
</svg>
